<template>
    <div class="not-found">
        <img src="/img/bg/not-found.png" alt="Solluti Tecnologias">
    </div>
</template>

<script>
    export default {
        name: "not-found",
    }
</script>

<style lang="scss" scoped>
    .not-found {
        @apply .flex .items-center .justify-center .w-screen .h-screen .overflow-hidden;
        background-color: #dbe8fb;

        img {
            @apply .w-4/5;

            @media(min-width: 1024px) {
                @apply .w-3/5;
            }

            @media(min-width: 1280px) {
                @apply .w-1/2;
            }
        }
    }
</style>
